<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>        
                <v-row class="pa-4" style="align-items: center;">
                    <h3>Add damage event</h3>
                    <span class="ml-4" style="color: #1976d2; background-color: rgba(25, 118, 210, 0.1); border: 1px solid #1976d2; border-radius: 8px; padding: 4px 10px; display: inline-flex; align-items: center;">
                        <v-icon color="#1976d2" size="18" class="mr-2">mdi-information</v-icon>{{ claim_description }}
                    </span>
                </v-row>
                <v-row class="mb-6"><v-divider></v-divider></v-row>

                <v-row no-gutters class="mx-5">
                    <v-col cols="4">
                        <status_selector :selected_eventstatus="hsmr_smst" label="Status" field="hsmr_smst"
                            @updateData="updateData" />
                    </v-col>
                </v-row>

                <v-row no-gutters class="mx-5">
                    <v-col cols=12>
                        <v-form v-model="hsmr_valid">
                            <v-textarea v-model="hsmr_text" rows="4" required label="Damage event text" :rules="descriptionRules">{{ hsmr_text }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

                <!-- <v-row no-gutters class="mx-5">
            <v-col cols=12>
              <span v-for="(link, idx) in links" :key="idx">
                  <span v-html="link.url"></span><span>&nbsp;<v-icon small v-on:click="deleteLink(link.id)">mdi-trash-can-outline</v-icon>&nbsp;&nbsp;</span>
              </span>              
              <span v-if="this.show_create_link_button"><span v-if="links != null && links.length > 0">&nbsp;</span><v-btn small plain v-on:click="showCreateLink()">create link</v-btn></span>
            </v-col>
          </v-row>
          <br>
          <div v-if="this.show_create_link_container">
            <v-container>
              <v-row dense ><span class="subtitle mx-6 mb-5">Create a new link</span></v-row>  
              <v-row no-gutters class="mx-5">
                <v-col cols=12>
                  <v-text-field dense v-model="url" label="URL"></v-text-field> 
                </v-col> 
              </v-row>
              <v-row no-gutters class="mx-5 mb-2">
                <v-col cols="10" xl="11" lg="10" md="9" sm="8" xs="4">
                  <v-text-field dense v-model="url_text" label="URL tekst"></v-text-field> 
                </v-col> 
                <v-col cols="2" xl="1" lg="2" md="3" sm="4" xs="8">
                  <span class="float-right"><v-icon v-on:click="closeCreateLink()" class="mt-2 ml-4">mdi-close</v-icon></span>              
                  <span v-if="save_ok" class="float-right">&nbsp;<v-icon v-on:click="createLink(url, url_text)" class="mt-2">mdi-content-save-outline</v-icon></span>              
                </v-col> 
              </v-row>     
            </v-container>   
          </div> -->

                <v-card fluid flat class="mt-0 pl-4 mb-4 pr-6">
                    <hokl_hosm_links :links="links" @updateData="updateData" />
                </v-card>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!hsmr_valid" v-on:click="addHsmr()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>

            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

// import {bus} from "../../../main";

// import mxnotifyhuovhosm from './mixins/notifyhuov_hosm';
// import mxnotifyhosmhsmr from './mixins/notifyhosm_hsmr';
// import mxcreatelinks from './mixins/createlinks';
// import mxfindwithattribute from '@/mixins/findwithattribute';

import status_selector from '@/components/huov/hosm/ui/status_selector.vue';
import hokl_hosm_links from '@/components/huov/ui/hokl_hosm_links.vue';

export default {
    props: {
        claim_description: String
    },
    components: {
        status_selector,
        hokl_hosm_links
    },
    data() {
        return {
            dialog: false,
            hsmr_valid: false,
            hsmr_text: '',
            encrid: '',
            hsmr_smst: '',
            links: [],
            descriptionRules: [
                v => !!v || "A description / value is required"
            ]
        }
    },
    //mixins:[mxnotifyhuovhosm,mxnotifyhosmhsmr,mxfindwithattribute,mxcreatelinks],
    methods: {
        open(encrid) {
            this.dialog = true;
            this.encrid = encrid;
            this.hsmr_text = '';
            this.hsmr_smst = 'new';
            this.links = [];
        },        
        updateData(data) {
            console.log('updateData', data);
            this[data.field] = data.value;
        },
        addHsmr() {
            this.$axios
                .post("ares/json/ares/huov/hosm/addHsmrv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHsmr"
                    },
                    addHsmr: {
                        hosm_encrid: this.encrid,
                        hsmr_text: this.hsmr_text,
                        hsmr_smst: this.hsmr_smst,
                        links: this.links,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$emit('updateData', 'refresh');
                        this.dialog = false; // close dialog + update
                    }
                });
        }

    }
}
</script>

<style scoped></style>